import { iBinderHeaderEnum } from '@ibinder/common-utils';
import { ADMIN_EVENT } from './consts';
import { publishMessage } from '@ibinder/ui-common-hooks';

let ac;

export const InitiateAbortController = () => {
  ac = new AbortController();
};

interface TenantProps {
  tenantId: string;
}

export const iBinderFetch =
  (p: TenantProps = null) =>
  async (url, options = {}): Promise<Response> => {
    const customHeaders = {
      'Content-Type': 'application/json',
      authorization: `Bearer ${localStorage.getItem('access_token')}`
    };

    if (p?.tenantId) {
      customHeaders[iBinderHeaderEnum.TENANTID] = p.tenantId;
    }

    if (localStorage.getItem('impersonation_token')) {
      customHeaders[iBinderHeaderEnum.IMPERSONATE] = localStorage.getItem(
        'impersonation_token'
      );
    }
    console.log('URL', url, customHeaders);
    const fetcher = fetch(url, {
      ...options,
      headers: {
        //@ts-ignore
        ...options?.headers,
        ...customHeaders
      },
      signal: ac?.signal ? ac.signal : null
    });

    fetcher
      .then(async (res) => {
        // Next, we dispatch the event.
        await publishMessage(ADMIN_EVENT.FETCH_RESPONSE, { detail: res });

        if (!res.ok) {
          ac.abort();
        }
      })
      .catch((err) => {
        console.log('ERROR');
      });

    return fetcher;
  };

export const noTenantFetch = iBinderFetch();
